var map = {
	"./accordion-arr-icon.svg": "e552",
	"./add-icon-gray.svg": "058c",
	"./add-icon.svg": "6209",
	"./adv-icon.svg": "226a",
	"./arr-sm-down-icon.svg": "b554",
	"./arr-sm-up-icon.svg": "d606",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./arrow-top.svg": "d162",
	"./arrow_end.svg": "7b40",
	"./arrow_top_2.svg": "5d71",
	"./attention.svg": "d178",
	"./avatar.svg": "f2e9",
	"./back-icon.svg": "8bcc",
	"./bag-icon.svg": "418c",
	"./bank-icon.svg": "69d2",
	"./basket-icon.svg": "7f26",
	"./blank-gray-icon.svg": "8842",
	"./blank-green-icon.svg": "75b0",
	"./blank-icon.svg": "5897",
	"./blocked-icon.svg": "b929",
	"./blocked-red-icon.svg": "9584",
	"./btn-arrow-icon.svg": "fc19",
	"./burger-collapse-icon.svg": "6455",
	"./burger-icon.svg": "6742",
	"./burger.svg": "ada2",
	"./calendar.svg": "b8bd",
	"./chat.svg": "9b69",
	"./checked.svg": "0aae",
	"./checklist-icon.svg": "f60c",
	"./checklist.svg": "f589",
	"./clients.svg": "b53a",
	"./close-icon.svg": "3e79",
	"./close-white-icon.svg": "b4cf",
	"./coin.svg": "b0cb",
	"./company-green-icon.svg": "531c",
	"./company-icon.svg": "e2d7",
	"./connect-green-icon.svg": "aef7",
	"./connect-icon.svg": "53f0",
	"./crop-icon.svg": "f384",
	"./deal-icon.svg": "eea7",
	"./delegation-icon.svg": "9922",
	"./delete.svg": "0d45",
	"./doc-blue-icon.svg": "f72f",
	"./doc-icon.svg": "1b31",
	"./documents.svg": "70cd",
	"./dots-horz.svg": "a91e",
	"./download.svg": "f28e",
	"./dropdown-icon.svg": "33b8",
	"./dropdown-side-arr-icon.svg": "35c0",
	"./empty-box.svg": "cd90",
	"./eraser.svg": "3b6f",
	"./error-icon.svg": "427a",
	"./eye-icon.svg": "7754",
	"./file-excel.svg": "472c",
	"./file-icon.svg": "446b",
	"./file-image.svg": "f944",
	"./file-pdf.svg": "d890",
	"./file-powerpoint.svg": "93ef",
	"./file-word.svg": "911d",
	"./fire-icon.svg": "9890",
	"./flip-icon.svg": "0bfd",
	"./floppy-icon.svg": "9685",
	"./folder.svg": "383d",
	"./fridge-active-icon.svg": "7f8d",
	"./fridge-icon.svg": "06a1",
	"./furniture-active-icon.svg": "09e8",
	"./furniture-icon.svg": "f80f",
	"./graph-icon.svg": "601c",
	"./graph.svg": "07ee",
	"./heart-fill.svg": "587a",
	"./heart.svg": "7d16",
	"./info-blue-icon.svg": "6ae3",
	"./info-card-green-icon.svg": "23ea",
	"./info-card-icon.svg": "50382",
	"./info-icon.svg": "2656",
	"./info.svg": "76ed",
	"./learning.svg": "4f7c",
	"./link.svg": "40a1",
	"./mail-icon.svg": "310f",
	"./manager-green-icon.svg": "09a9",
	"./manager-icon.svg": "f13f",
	"./menu-black-icon.svg": "b4ae",
	"./metro-icon.svg": "273e",
	"./mountains-icon.svg": "aaa7",
	"./move-icon.svg": "f567",
	"./no-image.svg": "eadf",
	"./no-wifi-icon.svg": "8438",
	"./note-icon.svg": "fe93",
	"./object.svg": "433f",
	"./office.svg": "3dec",
	"./options-icon.svg": "a035",
	"./organizations.svg": "f2a4",
	"./partner-icon.svg": "0f3b",
	"./partners.svg": "9c07",
	"./passport-green-icon.svg": "72ef",
	"./passport-icon.svg": "8cd7",
	"./pdf-file-white.svg": "9df0",
	"./pdf-file.svg": "140c",
	"./pen-icon.svg": "eae7",
	"./personal.svg": "7d6a",
	"./phone-call-icon.svg": "7128",
	"./phone-icon.svg": "8f38",
	"./planning.svg": "001a",
	"./profit.svg": "265a",
	"./question.svg": "9872",
	"./refrigerator-icon.svg": "2063",
	"./removed.svg": "f276",
	"./request.svg": "90ac",
	"./requisitions-green-icon.svg": "a673",
	"./requisitions-icon.svg": "5022",
	"./reserve.svg": "9f8f",
	"./rotating-icon.svg": "bdaa",
	"./save-icon.svg": "ea14",
	"./schedule.svg": "6b6f",
	"./search-icon.svg": "7669",
	"./search-white-icon.svg": "345e",
	"./search.svg": "d103",
	"./send-icon.svg": "66db",
	"./setting.svg": "5de8",
	"./share-icon-ios.svg": "464f",
	"./share-icon.svg": "c4ad",
	"./shopping-cart.svg": "b15e",
	"./shutdown-icon.svg": "08c7",
	"./slider-arr-w-left.svg": "01a2",
	"./slider-arr-w-right.svg": "af08",
	"./spb-metro.svg": "a251",
	"./staff-icon.svg": "1e8d",
	"./stage-move-icon.svg": "6d2c",
	"./staple-icon.svg": "91db",
	"./stay-home.svg": "e89f",
	"./strategy-icon.svg": "5277",
	"./tag-icon.svg": "7d94",
	"./target.svg": "0129",
	"./task-icon.svg": "110a",
	"./telegram-icon.svg": "ce52",
	"./tg-icon.svg": "8c87",
	"./transfer.svg": "f62e",
	"./turnOff-icon.svg": "c801",
	"./turnOff-red-icon.svg": "3d9f",
	"./tv-active-icon.svg": "16c1",
	"./tv-icon.svg": "7e0e",
	"./undo.svg": "34b1",
	"./user-card-green-icon.svg": "88e5",
	"./user-card-icon.svg": "6fe1",
	"./view.svg": "00ed",
	"./vk.svg": "13e3",
	"./warning.svg": "daa9",
	"./washer-active-icon.svg": "fe8c",
	"./washer-icon.svg": "8a64",
	"./whatsapp-icon.svg": "1f60",
	"./zoom-in.svg": "d3ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";